'use strict';

function isWithinInclusivityInterval(timestamp, inclusivityTimestampInterval) {
  const { start, end } = inclusivityTimestampInterval;
  const \uC2DC\uC791_\uBE44\uAD50_\uACB0\uACFC = start.inclusive ? timestamp >= start.timestamp : timestamp > start.timestamp;
  const \uC885\uB8CC_\uBE44\uAD50_\uACB0\uACFC = end.inclusive ? timestamp <= end.timestamp : timestamp < end.timestamp;
  return \uC2DC\uC791_\uBE44\uAD50_\uACB0\uACFC && \uC885\uB8CC_\uBE44\uAD50_\uACB0\uACFC;
}

module.exports = isWithinInclusivityInterval;
//# sourceMappingURL=isWithinInclusivityInterval.cjs.map
